import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		leaves: {},
		leavesArray: [],
		services: [],
	}),

	getters: {
		leaves(state) {
			return state.leavesArray;
		},
		services(state) {
			return state.services;
		},
	},

	actions: {
		async getAllServiceLeaves({commit}, {startTime, endTime}) {
			const response = await api.getAllServiceLeaves(startTime, endTime);
			const { leaves, services } = response.data || {};
			if (services?.length) {
				commit('setServices', services);
			}
			if (leaves?.length) {
				commit('setLeaves', leaves);
				return leaves.map((l) => l.id);
			}
		},
		deleteServiceLeave({commit}, leaveId) {
			commit('deleteLeave', leaveId);
		}
	},

	mutations: {
		setLeaves(state, leaves) {
			leaves.forEach((l) => {
				Vue.set(state.leaves, l.id, l);
			});
			Vue.set(state, 'leavesArray', Object.values(state.leaves));
		},
		deleteLeave(state, leaveId) {
			Vue.delete(state.leaves, leaveId);
			Vue.set(state, 'leavesArray', Object.values(state.leaves));
		},
		setServices(state, services) {
			Vue.set(state, 'services', services);
		},
	},
}